import PartnerDescriptionPage from "./partner-description-page";

const PARTNER_DESCRIPTION_PAGE_PATH = "/integrations/:solutionSlug";

export { PartnerDescriptionPage, PARTNER_DESCRIPTION_PAGE_PATH };
